export const INFERENCE_PATH = '/inference';

export const INFERENCE_MODEL_PATH = `${INFERENCE_PATH}/:collectionId/:modelId`;
export const INFERENCE_COLLECTION_PATH = `${INFERENCE_PATH}/:collectionId?`;
export const INFERENCE_COMPARE_PATH = '/inference-compare';
